import { ReportingFieldLookupDto } from 'tm3-core/api.dtos';
import FormStore from 'tm3-core/controls/forms/form-store';

class ReportingFieldStore extends FormStore<ReportingFieldLookupDto> {
  initialise(args: any): Promise<any> {
    this.validationRules = {
      displayName: { presence: { allowEmpty: false, message: 'Display Name is required' } },
      fieldName: { presence: { allowEmpty: false, message: 'Field Name is required' } },
      fieldType: { presence: { allowEmpty: false, message: 'Field Type is required' } },
      objectType: { presence: { allowEmpty: false, message: 'Type is required' } }
    };

    let res = new ReportingFieldLookupDto();
    res.objectType = 'R';
    res.fieldType = 'string';
    res.propagate = false;
    return Promise.resolve(res);
  }

  onSave(data: any) {
    let req = new ReportingFieldLookupDto();
    Object.assign(req, this.form.toJSON());
    return this.client
      .post(req)
      .then((x) => Promise.resolve(true))
      .catch((err) => {
        alert('There was a problem saving the reporting field. ' + err.responseStatus.message);
      });
  }

  beforeInitialise() {
    return;
  }

  onInitialise() {
    return;
  }
}

export default ReportingFieldStore;
